<template>
  <div>
    <div class="about">
      <div class="single-row">
        <div class="img-div">
          <img src="https://spkg.smartmice.cn/resources/images/official/platform/1.jpg">
          <div class="platform-title">
            <span>
              默沙东 Easy car 平台<span>/ 2019年</span>
            </span>
          </div>
        </div>
        <p>
          Easy car项目是通过搭建一个车辆整合的平台，实现使用人通过平台完成用车的预定，使用，确认结算的全流程操作；平台整合了滴滴，神州等线上专车平台，以及覆盖全国超过100个城市的线下车队供应商。通过统一的供应商接单平台，实现对会议用车的管理。
        </p>
        <p>平台的使用可以实现节省车辆使用成本，精准获取所有车辆使用合规数据及文件，同时使用人可以更加轻松快捷的通过一个平台完成各种类型，各种需求车辆的使用需求。</p>
      </div>
      <div class="double-row">
          <div class="img-div">
            <img src="https://spkg.smartmice.cn/resources/images/official/platform/2.jpg">
            <div class="platform-title">
                <span>辉瑞 YES 平台<span>/ 2016年</span></span>
            </div>
          </div>
          <p class="platform-text2">国内首创，全流程会议平台。连续2年获得辉瑞全球的合规大奖。开创端到端会议管理平台的先河；年会议量近20万场。</p>
      </div>
      <div class="single-row">
          <div class="img-div">
            <img src="https://spkg.smartmice.cn/resources/images/official/platform/4.jpg">
            <div class="platform-title"><span>罗氏 A1平台<span>/ 2018年</span></span></div>
          </div>
          <p>通过一站式平台，简化会议工作流程、支持一线用户更专注业务开展， 实现资源一站式采购，全流程端到端操作，多系统一站式整合，真正意义上实现 ALL IN ONE。</p>
      </div>
      <div class="double-row">
        <div class="img-div">
          <img src="https://spkg.smartmice.cn/resources/images/official/platform/5.jpg">
          <div class="platform-title"><span>礼来 Easy meeting 平台<span>/ 2018年</span></span></div>
        </div>
        <p>Easy meeting 平台是通过搭建一个会议资源整合的平台，实现使用人通过平台完成会议的全流程操作；平台整合了酒店，交通，用餐，现场执行人等会议资源，实现覆盖全国会议需求。</p>
        <p>Easy meeting 平台作为2019年度礼来global 最为重要的数字化变革的创新产品，受到礼来总部的极大关注。</p>
      </div>
      <div class="single-row">
        <div class="img-div">
          <img src="https://spkg.smartmice.cn/resources/images/official/platform/6.jpg">
          <div class="platform-title"><span>诺华制药 MEETING GO 平台<span>/ 2019年</span></span></div>
        </div>
        <p>为诺华中国打造全新的会议操作模式，一期上线品类包括酒店，外出用餐及外卖，会议交通，以及会议服务人员；更好的便捷前端销售的使用， 集中管理，集中支付，结算一键发起，数据一键汇总； 实现诺华制药要求的费用节省，合规管理，提高效能的三大要求。</p>
      </div>
      <div class="double-row">
        <div class="img-div">
          <img src="https://spkg.smartmice.cn/resources/images/official/platform/7.jpg">
          <div class="platform-title"><span>平安集团 MICE 平台<span>/ 2019年</span></span></div>
        </div>
        <p>由于平安集团在MICE 领域每年支出巨大，中智商展和平安集团旗下壹钱包电子商务有限公司签署了战略合作协议，双方团队从产品设计，到研发，共同打造一个适用于金融保险行业的MICE平台；</p>
        <p>平台的核心目的是管理金融保险公司所有MICE活动，以达到降低成本，强化监管，提升用户体验以及整合数据等目的。</p>
        <p>双方的战略合作，除了MICE平台的设计研发，技术运维及服务中心的建立，还包括全国的人才网络的使用、MICE落地服务、支付等多个领域展开全面合作，支持平安集团内部及外部客户的MICE 业务。</p>
      </div>
      <div class="single-row">
        <div class="img-div">
          <img src="https://spkg.smartmice.cn/resources/images/official/platform/8.jpg">
          <div class="platform-title">
            <span>
              艾尔建 艾微会 平台 
              <span>/ 2018年</span></span> 
          </div>
        </div>
        <p class="platform-text8">2018年8月， 全国40城市小会和商务宴请覆盖。</p>
      </div>
      <div class="double-row">
        <div class="img-div">
          <img src="https://spkg.smartmice.cn/resources/images/official/platform/9.jpg">
          <div class="platform-title"><span>活动兔 Eventcool 平台<span>/ 2019年</span></span></div>
        </div>
        <p class="platform-text9">一站式会议服务平台，专业会议顾问一对一全程跟踪，协助客户在线免费生成方案。</p>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Footer from '@/components/Footer'
export default {
  name: 'PlatformServices',
  components: {
    Footer
  }
}
</script>
<style lang="less" scoped>
@media (min-width: 997px) {
  .about {
    margin-top: 80px;
    overflow: hidden;
  }
}
@media (max-width: 997px) {
  .about {
    margin-top: 60px;
    overflow: hidden;
  }
}

@media(min-width: 767px) {
      .single-row {
        background: #F4F4F4;
        padding: 50px 0 56px 0;
        
      }
      .double-row {
        background: #FFFFFF;
        padding: 110px 0 152px 0;
      }
      p {
        width: 72%;
        margin: 0 auto;
        font-size: 16px;
        color: #666666;
        line-height: 28px;
      }
      p+p {
        margin-top: 26px;
      }
      .img-div {
        width: 56%;
        margin: 0 auto;
        position: relative;
        margin-bottom: 82px;
      }
      .img-div img {
        width: 100%;
      }
      .platform-title {
        position: absolute;
        bottom: -18px;
        width: 100%;
        text-align: center;
        height: 27px!important;
      }
      .platform-title span {
        background: #39C5D5;
        color: #FFFFFF;
        padding: 7px 13px;
        font-size: 20px;
      }
      .platform-title span span {
        font-size: 16px;
      }
    }

    @media(max-width: 767px) {
      .single-row {
        background: #F4F4F4;
        padding: 30px 0 32px 0;
      }
      .double-row {
        background: #FFFFFF;
        padding: 30px 0 32px 0;
      }
      p {
        padding: 0 30px;
        margin: 0 auto;
        font-size: 14px;
        color: #666666;
        line-height: 28px;
      }
      p+p {
        margin-top: 26px;
      }
      .img-div {
        position: relative;
        margin: 0 30px;
        margin-bottom: 42px;
      }
      .img-div img {
        width: 100%;
      }
      .platform-title {
        position: absolute;
        bottom: -18px;
        width: 100%;
        text-align: center;
        height: 27px!important;
      }
      .platform-title span {
        background: #39C5D5;
        color: #FFFFFF;
        padding: 7px 13px;
        font-size: 16px;
      }
      .platform-title span span {
        font-size: 12px;
      }
    }
    @media(min-width: 1190px) {
      .platform-text2 {
        text-align: center
      }
      .platform-text8 {
        text-align: center
      }
      .platform-text9 {
        text-align: center
      }
    }
    @media(max-width: 1190px) {
      .platform-text2 {
        text-align: left;
      }
      .platform-text8 {
        text-align: center
      }
      .platform-text9 {
        text-align: center
      }
    }
    @media(max-width: 840px) {
      .platform-text2 {
        text-align: left;
      }
      .platform-text8 {
        text-align: center
      }
      .platform-text9 {
        text-align: left
      }
    }
    @media(max-width: 767px) {
      .platform-text2 {
        text-align: left;
      }
      .platform-text8 {
        text-align: center
      }
      .platform-text9 {
        text-align: center
      }
    }
    @media(max-width: 596px) {
      .platform-text2 {
        text-align: left;
      }
      .platform-text8 {
        text-align: center
      }
      .platform-text9 {
        text-align: left;
      }
    }
    @media(max-width: 596px) {
      .platform-title span {
        background: #39C5D5;
        color: #FFFFFF;
        padding: 7px 13px;
        font-size: 12px;
      }
      .platform-title span span {
        font-size: 8px;
      }
      .platform-text2 {
        text-align: left;
      }
      .platform-text8 {
        text-align: left;
      }
      .platform-text9 {
        text-align: left;
      }
    }

</style>
